module.exports = __webpack_public_path__ + "img/icon_map_13_on_100.7a0d6a50.png";